/**
 * Bandeau cross-sell GothamDev — visible par défaut (HTML), masqué si fermé ou quota.
 */
(function () {
  const ROOT_ID = 'lgk-gd-cross';
  const STORAGE_KEY = 'lgk:gd-cross-sell';
  const SESSION_COUNTED = 'lgk:gd-cross-counted';
  const MAX_MONTHLY = 4;

  function dismissKey() {
    return 'lgk:gd-cross-dismissed:' + (window.location.pathname || '/');
  }

  function syncOffset(el) {
    if (!el) return;
    document.documentElement.style.setProperty('--lgk-gd-cross-offset', `${el.offsetHeight}px`);
  }

  function clearOffset() {
    document.documentElement.style.removeProperty('--lgk-gd-cross-offset');
  }

  function monthKey() {
    const d = new Date();
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
  }

  function readStore() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');
    } catch {
      return {};
    }
  }

  function writeStore(data) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    } catch {
      /* quota / mode privé */
    }
  }

  function monthlyCount() {
    return readStore()[monthKey()] || 0;
  }

  function shouldShow(el) {
    if (sessionStorage.getItem(dismissKey()) === '1') return false;

    const pageType = el?.dataset?.lgkGdCrossPage || '';
    if (pageType === 'index') return true;

    return monthlyCount() < MAX_MONTHLY;
  }

  function recordSessionShow(el) {
    if (sessionStorage.getItem(SESSION_COUNTED) === '1') return;
    if (el?.dataset?.lgkGdCrossPage === 'index') {
      sessionStorage.setItem(SESSION_COUNTED, '1');
      return;
    }

    const store = readStore();
    const key = monthKey();
    store[key] = (store[key] || 0) + 1;
    writeStore(store);
    sessionStorage.setItem(SESSION_COUNTED, '1');
  }

  function hide(el) {
    if (!el) return;
    el.classList.remove('is-visible');
    el.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('lgk-gd-cross-active');
    clearOffset();
  }

  function show(el) {
    if (!el) return;
    el.classList.add('is-visible');
    el.removeAttribute('aria-hidden');
    document.documentElement.classList.add('lgk-gd-cross-active');
    syncOffset(el);
    recordSessionShow(el);
  }

  function init() {
    const el = document.getElementById(ROOT_ID);
    if (!el) return;

    if (!shouldShow(el)) {
      hide(el);
      return;
    }

    show(el);

    const closeBtn = el.querySelector('[data-lgk-gd-cross-close]');
    const cta = el.querySelector('[data-lgk-gd-cross-cta]');

    closeBtn?.addEventListener('click', function () {
      sessionStorage.setItem(dismissKey(), '1');
      hide(el);
    });

    cta?.addEventListener('click', function () {
      sessionStorage.setItem(dismissKey(), '1');
    });

    window.addEventListener('resize', function () {
      if (el.classList.contains('is-visible')) syncOffset(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
